var $fa99f4a7b08c9c55$exports = {};
$fa99f4a7b08c9c55$exports = {
  "collapse": "Samenvouwen",
  "expand": "Uitvouwen"
};
export { $fa99f4a7b08c9c55$exports as default };